import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Login } from 'src/app/shared/model/login.model';
import { LoginService } from 'src/app/shared/services/login-service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
   login:Login = new Login();
   constructor(
    private userLogInServices:LoginService,
     private toastr: ToastrService,
      ){}

  submit(event: any) {
    debugger
    if (!this.login || !this.login.email) {
      this.toastr.error("Please enter a valid email address.");
      return;
    }

    const data = { email: this.login.email };

    this.userLogInServices.forgetPasswordForAdmin(data).subscribe(
      (res: any) => {
        if (res) {
          this.toastr.success("The reset link has been sent successfully.");
        } else {
          this.toastr.error("An error occurred. Please try again.");
        }
      },
      (err: any) => {
        console.error("API Error: ", err);
        this.toastr.error("Failed to send the reset link. Please check your network and try again.");
      }
    );
  }
          
}
